import { render, staticRenderFns } from "./LsModal.vue?vue&type=template&id=2e420b31&scoped=true&"
import script from "./LsModal.vue?vue&type=script&lang=js&"
export * from "./LsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e420b31",
  null
  
)

export default component.exports